//const StoreApi = "http://localhost:5152/api";
const StoreApi = "https://storeapi.thepalmshotel.net/api";
//const TaskApi = "http://localhost:5047/api";
const TaskApi = "https://taskapi.thepalmshotel.net/api";

const creditPurchaseApi = "https://app.thepalmshotel.net/api/home";
//const creditPurchaseApi = "https://localhost:5001/";

const Urls = {
  user: {
    get: `${StoreApi}/StoreUsers/`,
    post: `${StoreApi}/StoreUsers/signin`,
    signinchecker: `${StoreApi}/StoreUsers/signinchecker`,
    create: `${StoreApi}/StoreUsers/SaveUser`,
    update: `${StoreApi}/StoreUsers/UpdateUser/`,
    dropdown: `${StoreApi}/StoreUsers/`,
  },
  product: {
    get: `${StoreApi}/StoreProduct/`,
    post: `${StoreApi}/StoreProduct/SaveProduct`,
    update: `${StoreApi}/StoreProduct/updateProduct/`,
    delete: `${StoreApi}/StoreProduct/deleteProduct/`,
    notification: `${StoreApi}/StoreProduct/`,
    underLevel: `${StoreApi}/StoreProduct/`,
  },
  supplier: {
    get: `${StoreApi}/StoreSupplier/`,
    post: `${StoreApi}/StoreSupplier/SaveSupplier`,
    update: `${StoreApi}/StoreSupplier/updateSuppliers/`,
    delete: `${StoreApi}/StoreSupplier/deleteSupplier/`,
  },
  consumer: {
    get: `${StoreApi}/StoreConsumer/`,
    post: `${StoreApi}/StoreConsumer/SaveConsumer`,
    update: `${StoreApi}/StoreConsumer/updateConsumer/`,
    delete: `${StoreApi}/StoreConsumer/deleteConsumer/`,
  },
  Category: {
    get: `${StoreApi}/StoreCategory/`,
    post: `${StoreApi}/StoreCategory/saveCategory`,
    update: `${StoreApi}/StoreCategory/UpdateCategory/`,
    delete: `${StoreApi}/StoreCategory/deleteCategory/`,
  },
  Units: {
    get: `${StoreApi}/StoreUnites/`,
    post: `${StoreApi}/StoreUnites/saveUnites`,
    update: `${StoreApi}/StoreUnites/UpdateUnites/`,
    delete: `${StoreApi}/StoreUnites/deleteUnites/`,
  },
  order: {
    get: `${StoreApi}/StoreProductOrder/`,
    post: `${StoreApi}/StoreProductOrder/SaveProductOrderDetails`,
    delete: `${StoreApi}/StoreProductOrder/deleteOrderedProduct/`,
    create: `${StoreApi}/StoreProductOrder/SaveProductOrder`,
    getLastGenId: `${StoreApi}/StoreProductOrder/`,
  },
  request: {
    get: `${StoreApi}/StoreRequestOrder/`,
    post: `${StoreApi}/StoreRequestOrder/SaveRequestOrderDetails`,
    create: `${StoreApi}/StoreRequestOrder/SaveRequestOrder`,
    update: `${StoreApi}/StoreRequestOrder/updateRequestOrderDetails/`,
    delete: `${StoreApi}/StoreRequestOrder/deleteRequestedProduct/`,
    monthlyRequests: `${StoreApi}/StoreRequestOrder/`,
    getLastGenId: `${StoreApi}/StoreRequestOrder/`,
    getAllRequested: `${StoreApi}/StoreRequestOrder/`,
    update_request: `${StoreApi}/StoreRequestOrder/modifyRequestOrder/`,
    update_details: `${StoreApi}/StoreRequestOrder/modifyRequestOrderDetails/`,
    getRequestedReport: `${StoreApi}/StoreRequestOrder/`,
  },
  roles: {
    get: `${StoreApi}/StoreUserRole/getUserWithRoles`,
    post: `${StoreApi}/StoreUserRole/SaveUserRole`,
    update: `${StoreApi}/StoreUserRole/UpdateUserRoles`,
  },
  business: {
    get: `${StoreApi}/StoreBusiness/`,
    update: `${StoreApi}/StoreBusiness/UpdateBusiness/`,
  },
  materials: {
    get: `${TaskApi}/MaterialRequest/`,
    update: `${TaskApi}/MaterialRequest/UpdateTaskMaterialRequest/`,
    getLastRequestGenId: `${TaskApi}/Tasks/`,
  },
  creditPurchase: {
    get: `${creditPurchaseApi}/vendors`,
  },
};

export default Urls;
